import { Typography, Box } from '@mui/material';
import ExcelUploadSection from './ExcelUploadSection';

const DocsRoomTypes = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Classroom Types
      </Typography>

      <Typography variant="body1" paragraph>
        Classroom Types define the different categories of classrooms available
        as per the course needs. This helps in ensuring that subjects are
        allocated to appropriate spaces, such as lecture halls, computer labs,
        smart classrooms, or science labs.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Adding a Classroom Type
      </Typography>

      <ExcelUploadSection />

      <Typography variant="body1" paragraph>
        To add a new classroom type, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Go to the <strong>Classroom Types</strong> section in the dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click <strong>Add</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter a code for the classroom type (e.g., Lecture, CSLab,
            ScienceLab).
          </Typography>
        </li>
        {/* <li>
          <Typography variant="body1">
            Optionally, add a description to specify its use.
          </Typography>
        </li> */}
        <li>
          <Typography variant="body1">
            Click <strong>Save</strong> to create the type.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Managing Classroom Types
      </Typography>
      <Typography variant="body1" paragraph>
        You can modify or delete classroom types as needed:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Editing:</strong> Click on the edit(pencil) button to modify
            classroom type details.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Deleting:</strong> Click on the edit(pencil) button and
            select delete if it is no longer needed.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsRoomTypes;
